'use strict';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {IoptionElemet} from '../../../../shared/interfaces/IoptionElemet';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs';
import {get, find} from 'lodash';
import {ValuesetService} from "../../../../worklist/services/valueset.service";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {IValuesetItem} from "../../../../worklist/interfaces/valueset.interface";

const DISCIPLINE_VALUESET_NAME: string = "PATHWAY-DISCIPLINE";

@Component({
  selector: 'gen-curation-cloning-selection',
  templateUrl: './curation-cloning-selection.component.html',
  styleUrls: ['./curation-cloning-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationCloningSelectionComponent implements OnInit {
  public payload: { formName: string, options: IoptionElemet[] };
  public tunnel$: Subject<any>;
  public callback: (model) => Observable<Response>;
  public selectedFormName: string;
  public form: any;
  public formData: any = {};
  public isValid: boolean;
  public submitted: boolean;
  public curationKey: string;
  public currentField: string;
  public fieldToChange: string;

  constructor(private _userActionCreatorService: UserActionCreatorService, private _valuesetService: ValuesetService, private _changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.tunnel$
      .asObservable()
      .filter(value => value.emitter !== 'child')
      .subscribe(next => {
        next.value && this.submit(this.payload);
      });
    const fieldToChange = this.payload['itemData']['fieldToChange'];
    this.selectedFormName = this.payload['formName'];
    this.formData = this.payload['itemData']['curation'];

    if (get(this.formData, 'type') === 'pathwaybpmn' || get(this.formData, 'type') === 'placement') {
      this.formatDisciplineAndDiseaseValues();
    }

    this.curationKey = get(this.formData, fieldToChange['curationKey'], '');
    this.fieldToChange = fieldToChange['fieldDsp'].toLowerCase();
    this.currentField = get(this.formData, fieldToChange['fieldName'], '');
  }

  updateForm(form) {
    this.form = form;
  }

  updateValidate(validate: boolean) {
    this.isValid = validate;
  }

  submit(model) {
    this.submitted = true;
    if (!(this.isValid)) {
      return;
    }

    // temp condition until we integrate aberration to the generic flow
    if (get(this.payload, 'itemData.curation.type') === 'aberration') {
      model = {selectedDisease: this.form['disease'], curation: this.formData};
    } else {
      model = {form: this.form, curation: this.formData};
    }

    this.callback(model).subscribe((model) => {
      this.tunnel$.next({emitter: 'child', value: model});
    });
  }

  /**
   * change discipline field from discipline: "disciplineName" to discipline: { code: "codeNumber", display: "disciplineName" }
   * in order to display it correctly in dropdown input element.
   * reset disease value to prevent clone with the same disease
   * @private
   */
  private formatDisciplineAndDiseaseValues(): void {
    const discipline = get(this.formData, 'discipline', null);
    // there is a field called 'discipline.code' in this.formData which is
    // different from the field 'discipline' with value {code: "...", display: "..."}
    if (!discipline?.code) {
      const disciplineCode = get(this.formData, 'discipline.code', "1");

      //Set formData['discipline'] initial value for immediately displaying of the discipline name in the clone's popup
      this.formData['discipline'] = {code: disciplineCode, display: discipline};
      this._changeDetector.markForCheck();

      //Override the default discipline code - "1" by the discipline code taken from the discipline value set
      this.setDisciplineCodeFromValueSet(discipline, disciplineCode);
    }

    this.formData['disease'] = null;
    this._changeDetector.markForCheck();
  }

  private setDisciplineCodeFromValueSet(discipline: any, disciplineCode: string): void {
    let disciplineValueSet: IValuesetItem[] = [];
    this._userActionCreatorService.getCurrentUser()
      .subscribe(user => {
        this._valuesetService.getValuesetItems(DISCIPLINE_VALUESET_NAME, '', user.organization)
          .subscribe(res => {
              if (res) {
                this._valuesetService.getValues(res.json(), user.organization)
                  .map(item => {
                    disciplineValueSet.push(item);
                  });

                if (disciplineValueSet.length > 0) {
                  let valueSet: IValuesetItem = find(disciplineValueSet, (item: IValuesetItem) => {
                    return item.isActive === "Active" && item.display === discipline;
                  });
                  disciplineCode = valueSet?.code ?? disciplineCode;
                }
              }
              this.formData['discipline'] = {code: disciplineCode, display: discipline};
              this._changeDetector.markForCheck();
            },
            () => {
              console.log('Failed to get the valueset ', DISCIPLINE_VALUESET_NAME);
            }
          );
      });
  }
}
